/** Arabic product names keyed by English name */
export const PRODUCT_NAMES_AR = {
  'Bleu de Chanel': 'بلو دي شانيل',
  'Boss Bottled': 'بوس بوتلد',
  Aventus: 'أفنتوس',
  Fahrenheit: 'فارنهايت',
  'Lacoste Black': 'لاكوست بلاك',
  'Acqua Di Gio': 'أكوا دي جيو',
  'The One': 'ذا وان',
  Legend: 'ليجند',
  'Stronger With You': 'سترونجر ويذ يو',
  'Boss The Scent': 'بوس ذا سينت',
  "Black XS L'Exces": 'بلاك إكس إس ليكسس',
  Eros: 'إيروس',
  'Ultra Male': 'ألترا ميل',
  'Lacoste White': 'لاكوست وايت',
  Voyage: 'فوياج',
  'Dunhill Desire': 'دنهل ديزاير',
  Y: 'واي',
  'One Million Elixir': 'وان ميليون إليكسير',
  'One Million Lucky': 'وان ميليون لاكي',
  Sauvage: 'سوفاج',
  'Azzaro Chrome': 'أزارو كروم',
  'Le Male Elixir': 'لو ميل إليكسير',
  'The Most Wanted': 'ذا موست وانتد',
  '212 Men NYC': '212 رجال نيويورك',
  'Marbelt Man': 'ماربلت مان',
  'Silver Mountain Water': 'سيلفر ماونتن ووتر',
  Phantom: 'فانتوم',
  Invictus: 'إنفكتوس',
  K: 'كيه',
  'Silver Scent': 'سيلفر سنت',
  'Yara Candy': 'يارا كاندي',
  'Moon Sparkle': 'مون سباركل',
  Idôle: 'آيدول',
  'Vanilla 28': 'فانيليا 28',
  'Good Girl': 'جود جيرل',
  'Escada Collection': 'مجموعة إسكادا',
  'La Nuit Trésor': 'لا نوي تريزور',
  Libre: 'ليبري',
  Scandal: 'سكاندال',
  'Roberto Cavalli': 'روبرتو كافالي',
  'Modern Princess': 'مودرن برينسيس',
  'Bare Vanilla': 'بير فانيليا',
  "Because It's You": 'بيكوز إتس يو',
  Bombshell: 'بومبشيل',
  'Agua Del Sol': 'أكوا ديل سول',
  'Black Opium': 'بلاك أوبيوم',
  'Vanilla Candy Rock Sugar': 'فانيليا كاندي روك شوغر',
  'Sí Passione': 'سي باشون',
  'Midnight Fantasy': 'ميدنايت فانتازي',
  Signature: 'سيجنيتشر',
  'Private Show': 'برايفت شو',
  Goddess: 'غوديس',
  'Black XS Potion': 'بلاك إكس إس بوشن',
  Sí: 'سي',
  'Roses Vanille': 'روز فانيل',
  "J'adore": 'جادور',
  'La Vie Est Belle': 'لا في إي بيل',
  Olympea: 'أولمبيا',
  Fantasy: 'فانتازي',
  'Burberry Her': 'بربري هير',
  'Very Sexy Now': 'فيري سكسي ناو',
  'Love Is Heavenly': 'لوف إز هيفنلي',
  'Wanted Girl': 'وانتد جيرل',
  'Paris Hilton': 'باريس هيلتون',
  'Miss Dior Chérie': 'ميس ديور شيري',
  'Katy Perry': 'كاتي بيري',
  Icon: 'أيكون',
  'Voce Viva': 'فوتشي فيفا',
  Xerjoff: 'زيرجوف',
  Maghnawi: 'مغناوي',
  'She Oud': 'شي عود',
  'Mukhalaat Maa El Thahab': 'مخاليط مع الذهب',
  'Amber Desire': 'عنبر ديزاير',
  'Musk Al Tahara': 'مسك الطهارة',
  'Musk Cherry': 'مسك شيري',
  'Black Afgano': 'بلاك أفغانو',
  Seqmesk: 'سقمسك',
  'Al Fares Al Asmar': 'الفارس الأسمر',
  'Silk Musk': 'سيلك مسك',
  Kalemat: 'كلمات',
  'Black Orchid': 'بلاك أوركيد',
  'Strawberry Musk': 'مسك الفراولة',
  'Al Ghareeb': 'الغريب',
  'Bianco Latte': 'بيانكو لاتيه',
  Kalan: 'كالان',
  'Jasphil Chill': 'جاسفيل تشيل',
  Layton: 'لايتون',
  'Musk Al Tahara Pomegranate': 'مسك الطهارة رمان',
  Tuxedo: 'توكسيدو',
  'Sweet Musk': 'سويت مسك',
  'Hersh Laheeb': 'حرش لاهب',
  Khamrah: 'خمرة',
  Percival: 'بيرسيفال',
  'Deja Vu': 'ديجا فو',
  'Stronger With You Amber': 'سترونجر ويذ يو عنبر',
  'Alf Leila Wa Leila (1001 Nights)': 'ألف ليلة وليلة',
  Hacivat: 'هاسيفات',
  'Al Hajar Al Aswad (The Black Stone)': 'الحجر الأسود',
  'Imperial Valley': 'إمبريال فالي',
  'Erba Pura': 'إيربا بورا',
  'Amber Malaki': 'عنبر ملكي',
  Daarej: 'دارج',
  Accento: 'أكسنتو',
  'Historic Sahara': 'هيستوريك صحراء',
  'Special Nisho': 'سبيشال نيشو',
  Megamare: 'ميجاماري',
  'Pomegranate Musk': 'مسك الرمان',
  'Sir Al Khulood': 'سر الخلود',
  Shaghaf: 'شغف',
  'Baccarat Rouge 540': 'باكارات روج 540',
  'Gobar El Thahab': 'جبار الذهب',
  'Arabians Tonka': 'عربيانز تونكا',
  'Ana Abiyedh': 'أنا أبيض',
  Manifesto: 'مانيفستو',
  'Al Khitam Musk': 'مسك الختام',
  'Black Star': 'بلاك ستار',
  'Blue Diamond Aqua': 'بلو دايموند أكوا',
  'Body Musk Arabic Collection': 'مسك الجسم المجموعة العربية',
  'Body Oud Cardamom': 'عود الجسم بالهيل',
  'Candy Musk': 'مسك كاندي',
  'Cedar of Lebanon': 'أرز لبنان',
  'Emerald Soul': 'إميرالد سول',
  'Brazilian Tobacco': 'تبغ برازيلي',
  'Black Carbon Diamond': 'بلاك كاربون دايموند',
  'Diamond Collection Mini 10 in 1': 'مجموعة دايموند ميني 10 في 1',
  'Al Shams Musk': 'مسك الشمس',
  'Irth Collection': 'مجموعة إرث',
  'Hair Length Oil': 'زيت طول الشعر',
  'Lady Sukoon': 'ليدي سكون',
  'Musk Collection': 'مجموعة المسك',
  'Nude Coral Diamond': 'نود كورال دايموند',
  'Prestige Black': 'بريستيج بلاك',
  'Prestige Ruby': 'بريستيج روبي',
  Serious: 'سيريوس',
  'Ranat Khalkhal': 'رنة خلكال',
  'Ranet Khalkhal': 'رنة خلكال',
  Royale: 'رويال',
  'Royale Blue': 'رويال بلو',
  'Satin Body Oud': 'ساتين بودي عود',
  Shahra: 'شهرة',
  'Spanish Tobacco': 'تبغ إسباني',
  'Summer Collection': 'مجموعة الصيف',
  'Tobacco Collection': 'مجموعة التبغ',
  'Tobacco Body Oud': 'عود الجسم تبغ',
  'Vintage Tobacco': 'تبغ فينتاج',
  'White Regent Diamond': 'وايت ريجنت دايموند',
};

export const BRANDS_AR = {
  Chanel: 'شانيل',
  'Hugo Boss': 'هيوغو بوس',
  Creed: 'كريد',
  Dior: 'ديور',
  Lacoste: 'لاكوست',
  Armani: 'أرماني',
  'Dolce & Gabbana': 'دولتشي آند غابانا',
  Montblanc: 'مون بلان',
  'Paco Rabanne': 'باكو رابان',
  Versace: 'فيرساتشي',
  'Jean Paul Gaultier': 'جان بول غوتييه',
  Nautica: 'نوتيكا',
  Dunhill: 'دنهيل',
  'Yves Saint Laurent (YSL)': 'إيف سان لوران',
  Azzaro: 'أزارو',
  'Carolina Herrera': 'كارولينا هيريرا',
  Lithioo: 'ليثيو',
  'Jacques Bogart': 'جاك بوجار',
  Lattafa: 'لطافة',
  Escada: 'إسكادا',
  Lancôme: 'لانكوم',
  Kayali: 'كايلي',
  'Roberto Cavalli': 'روبرتو كافالي',
  Lanvin: 'لانفين',
  "Victoria's Secret": 'فيكتوريا سيكرت',
  'Britney Spears': 'بريتني سبيرز',
  Burberry: 'بربري',
  Mancera: 'مانسيرا',
  Rasasi: 'رساسي',
  Afnan: 'أفنان',
  Nishane: 'نيشان',
  'Orto Parisi': 'أورتو باريسي',
  'Maison Francis Kurkdjian': 'فرانسيس كوردجيان',
  Montale: 'مونتال',
  'Swiss Arabian': 'سويس أريبيان',
  'Tom Ford': 'توم فورد',
  'Parfums de Marly': 'بارفوم دي مارلي',
  Nasomatto: 'ناسوماتو',
  'Arabian Oud': 'العربية للعود',
  Gissah: 'قصة',
  Chopard: 'شوبارد',
  Sospiro: 'سوسبيرو',
  'Al Khitam': 'الختام',
  IBRAQ: 'إبراق',
  'Diamond Collection': 'مجموعة دايموند',
  'Al Majed Oud': 'الماجد للعود',
  'Ibrahim Al Qurashi': 'إبراهيم القرشي',
  Irth: 'إرث',
  Jadayel: 'جدائل',
  'Lady Sukoon': 'ليدي سكون',
  Prestige: 'بريستيج',
  'Abdul Samad Al Qurashi': 'عبدالصمد القرشي',
  'Body Oud': 'بودي عود',
  Sahara: 'صحراء',
  'Lithioo Collection': 'مجموعة ليثيو',
};

export const SECTION_META_AR = {
  men: {
    category: 'عطر رجالي',
    description:
      'عطر رجالي راقٍ بثبات وقوة استثنائية. مثالي للنهار والمساء ويمنحك حضوراً واثقاً.',
    ingredientSets: [
      ['برغموت', 'أرز', 'فيتيفر', 'عنبر'],
      ['جريب فروت', 'لافندر', 'باتشولي', 'مسك'],
      ['هيل', 'جلد', 'تونكا', 'صندل'],
    ],
    benefitSets: [
      ['حضور جريء وواثق من الصباح حتى المساء', 'ثبات ممتاز على البشرة والملابس', 'مثالي للعمل والمناسبات'],
      ['افتتاحية منعشة مع قاعدة دافئة رجالية', 'انتشار متوازن يلفت الانتباه دون إزعاج', 'عطر مميز يعكس أسلوبك'],
    ],
  },
  women: {
    category: 'عطر نسائي',
    description:
      'عطر نسائي أنيق بمزيج راقٍ من الزهور والدفء. يترك أثراً فاخراً لا يُنسى.',
    ingredientSets: [
      ['ورد', 'ياسمين', 'فانيليا', 'مسك'],
      ['بيوني', 'كمثرى', 'عنبر', 'مسك أبيض'],
      ['زهر البرتقال', 'تونكا', 'صندل', 'باتشولي'],
    ],
    benefitSets: [
      ['أناقة ناعمة وملحوظة يومياً', 'تركيبة طويلة الأمد طوال اليوم', 'مثالي للمناسبات والاستخدام اليومي'],
      ['طابع أنثوي مشرق بلمسة ناعمة', 'عطر يستحق الإطراء ويشعرك بالفخامة', 'يتناسب من النهار إلى المساء'],
    ],
  },
  special: {
    category: 'مجموعة مميزة',
    description:
      'تركيبة حصرية مستوحاة من العطور النيش بعمق شرقي غني. لعشاق العطور الفاخرة المميزة.',
    ingredientSets: [
      ['عود', 'عنبر', 'زعفران', 'مسك'],
      ['ورد', 'عود', 'صندل', 'فانيليا'],
      ['بخور', 'عنبر رمادي', 'تونكا', 'بنزوين'],
    ],
    benefitSets: [
      ['بروفايل شرقي فاخر وثابت', 'عطر بارز للمساء والاحتفالات', 'زيوت فاخرة لانتشار عميق'],
      ['شخصية فريدة تبرز عن العطور الشائعة', 'مثالي للهدايا واللحظات الخاصة', 'قاعدة غنية تتطور بجمال على البشرة'],
    ],
  },
  original: {
    category: 'منتج أصلي',
    description:
      'عطر أصلي 100% من علامات موثوقة. عبوة أصلية وأداء طويل الأمد يمكنك الاعتماد عليه.',
    ingredientSets: [
      ['زيوت فاخرة', 'نوتات طبيعية', 'قاعدة ثابتة'],
      ['خلطة أصلية', 'انتشار قوي', 'طابع العلامة الأصلي'],
    ],
    benefitSets: [
      ['أصلي 100% — ليس تقليداً', 'علامة موثوقة بجودة مثبتة', 'مثالي للاستخدام الشخصي أو الهدايا'],
      ['متوفر بأحجام متعددة', 'ثبات قوي على البشرة والملابس'],
    ],
  },
};

export const INGREDIENTS_AR = {
  Bergamot: 'برغموت',
  Cedarwood: 'أرز',
  Vetiver: 'فيتيفر',
  Amber: 'عنبر',
  Grapefruit: 'جريب فروت',
  Lavender: 'لافندر',
  Patchouli: 'باتشولي',
  Musk: 'مسك',
  Cardamom: 'هيل',
  Leather: 'جلد',
  'Tonka Bean': 'تونكا',
  Sandalwood: 'صندل',
  Rose: 'ورد',
  Jasmine: 'ياسمين',
  Vanilla: 'فانيليا',
  Peony: 'بيوني',
  Pear: 'كمثرى',
  'White Musk': 'مسك أبيض',
  'Orange Blossom': 'زهر البرتقال',
  Oud: 'عود',
  Saffron: 'زعفران',
  Incense: 'بخور',
  Ambergris: 'عنبر رمادي',
  Benzoin: 'بنزوين',
  'Premium oils': 'زيوت فاخرة',
  'Natural accords': 'نوتات طبيعية',
  'Long-lasting base notes': 'قاعدة ثابتة',
  'Authentic blend': 'خلطة أصلية',
  'Rich projection': 'انتشار قوي',
  'Signature brand character': 'طابع العلامة الأصلي',
};

export const BENEFITS_AR = {
  'Bold, confident presence from morning to night': 'حضور جريء وواثق من الصباح حتى المساء',
  'Excellent longevity on skin and clothes': 'ثبات ممتاز على البشرة والملابس',
  'Ideal for work, events, and evenings out': 'مثالي للعمل والمناسبات',
  'Fresh opening with a warm, masculine dry-down': 'افتتاحية منعشة مع قاعدة دافئة رجالية',
  'Balanced sillage that turns heads without overwhelming': 'انتشار متوازن يلفت الانتباه',
  'A signature scent that defines your style': 'عطر مميز يعكس أسلوبك',
  'Soft yet noticeable aura for daily elegance': 'أناقة ناعمة وملحوظة يومياً',
  'Long-lasting formula for all-day freshness': 'تركيبة طويلة الأمد طوال اليوم',
  'Perfect for special occasions and everyday luxury': 'مثالي للمناسبات والاستخدام اليومي',
  'Feminine, radiant character with a smooth finish': 'طابع أنثوي مشرق بلمسة ناعمة',
  'Compliment-worthy scent that feels premium': 'عطر يستحق الإطراء ويشعرك بالفخامة',
  'Layers beautifully from day to evening': 'يتناسب من النهار إلى المساء',
  'Opulent, long-lasting oriental profile': 'بروفايل شرقي فاخر وثابت',
  'Statement scent for evenings and celebrations': 'عطر بارز للمساء والاحتفالات',
  'Premium oils for deep, luxurious projection': 'زيوت فاخرة لانتشار عميق',
  'Unique character that stands out from mass market': 'شخصية فريدة تبرز عن العطور الشائعة',
  'Ideal for gifting and special moments': 'مثالي للهدايا واللحظات الخاصة',
  'Rich dry-down that evolves beautifully on skin': 'قاعدة غنية تتطور بجمال على البشرة',
  '100% original — not an imitation': 'أصلي 100% — ليس تقليداً',
  'Trusted brand with proven quality': 'علامة موثوقة بجودة مثبتة',
  'Ideal for personal use or gifting': 'مثالي للاستخدام الشخصي أو الهدايا',
  'Available in multiple bottle sizes': 'متوفر بأحجام متعددة',
  'Strong longevity on skin and clothes': 'ثبات قوي على البشرة والملابس',
};
